/*
 *
 * ForgotPasswordPage constants
 *
 */

export const PASSWORD_RESET_REQUEST_REQUEST = 'src/ForgotPasswordPage/PASSWORD_RESET_REQUEST_REQUEST';
export const PASSWORD_RESET_REQUEST_SUCCESS = 'src/ForgotPasswordPage/PASSWORD_RESET_REQUEST_SUCCESS';
export const PASSWORD_RESET_REQUEST_FAILURE = 'src/ForgotPasswordPage/PASSWORD_RESET_REQUEST_FAILURE';
export const PASSWORD_RESET_REQUEST = 'src/ForgotPasswordPage/PASSWORD_RESET_REQUEST';
export const PASSWORD_RESET_SUCCESS = 'src/ForgotPasswordPage/PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_FAILURE = 'src/ForgotPasswordPage/PASSWORD_RESET_FAILURE';
export const REQUEST_ANOTHER = 'src/ForgotPasswordPage/REQUEST_ANOTHER';
export const SET_COMPONENT_TO_RENDER = 'src/ForgotPasswordPage/SET_COMPONENT_TO_RENDER';

export const REQUEST_FORM = 'REQUEST_FORM';
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS';
export const REDIRECT_TO_SIGN_IN = 'REDIRECT_TO_SIGN_IN';
export const PASSWORD_RESET_FORM = 'PASSWORD_RESET_FORM';
export const RESET_FORGOT_PASSWORD_STATE = 'RESET_FORGOT_PASSWORD_STATE'
export const INVALID_PASSWORD_RESET_FORM = 'INVALID_PASSWORD_RESET_FORM';
export const HAS_RPS_PASSWORD_ERROR = "HAS_RPS_PASSWORD_ERROR";
export const HAS_RPS_VALID_PASSWORD = "HAS_RPS_VALID_PASSWORD";



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordPage/constants.js